import { cva } from 'class-variance-authority'

/** Synthetic list key for the "select all" option. Never stored in form values. */
export const SELECT_ALL_ID = '__select_all__'

export const SELECT_FIELD_HEIGHT = 'h-6'
export const SELECT_FIELD_PADDING = 'px-2'

export const selectFieldCva = cva(
  'border-px border-brand-2-200 bg-white outline-none outline-2 outline-offset-2 hd:border-1.5',
  {
    variants: {
      isOpen: {
        true: 'border-brand-2-900',
        false: 'data-[hovered]:border-brand-1-900',
      },
      isFocusVisible: {
        true: 'outline-2 outline-offset-2 outline-brand-1-600',
      },
      hasError: {
        true: 'border-error-fg',
      },
      isDisabled: {
        true: 'pointer-events-none border-brand-2-200 bg-brand-2-50',
        false: null,
      },
    },
  },
)

export const selectValueCva = cva('text-brand-2-900', {
  variants: {
    isDisabled: {
      true: 'text-brand-2-400',
      false: null,
    },
  },
})

export const SELECT_OPTION_CLASSNAME = `${SELECT_FIELD_PADDING} flex w-full items-center gap-1 border-b-px border-brand-2-200 text-brand-2-900 outline-none last:border-none`
